import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Select,
} from '@chakra-ui/react';

const FlowAssignModal = ({
  isOpen,
  onClose,
  currentItem,
  allFlows,
  onSave,
}) => {
  const [selectedFlowId, setSelectedFlowId] = React.useState(
    currentItem?.linkedFlowId || ''
  );
  const [selectedFlowName, setSelectedFlowName] = React.useState(
    currentItem?.linkedFlowName || ''
  );

  const handleChange = e => {
    const selected = allFlows.find(flow => flow.id === e.target.value);
    setSelectedFlowId(selected?.id);
    setSelectedFlowName(selected?.name);
  };

  const handleSave = () => {
    if (selectedFlowId && selectedFlowName) {
      onSave(selectedFlowId, selectedFlowName);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Choose a Flow</ModalHeader>
        <ModalBody>
          <Select
            placeholder="Choose"
            value={selectedFlowId}
            onChange={handleChange}
          >
            {allFlows.map(flow => (
              <option key={flow.id} value={flow.id}>
                {flow.name}
              </option>
            ))}
          </Select>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" ml={3} onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FlowAssignModal;
